import { gql, useMutation } from "@apollo/client";
import React, { ReactElement } from "react";

import {
  CreateCommunityEntityMutationMutation,
  CreateCommunityEntityMutationMutationVariables
} from "../../../../schemaTypes";

import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../../utils/normalizeErrors";

export const createCommunityEntityMutation = gql`
  mutation CreateCommunityEntityMutation(
    $input: CreateCommunityEntityInput!
  ) {
    createCommunityEntity(
      input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateCommunityEntity: (
        values: CreateCommunityEntityMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createCommunityEntityData: CreateCommunityEntityMutationMutation | null | undefined;
    }
  ) => ReactElement | null;
}

export const CreateCommunityEntityController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateCommunityEntityMutationMutation,
    CreateCommunityEntityMutationMutationVariables
  >(createCommunityEntityMutation);

  const submitCreateCommunityEntity = async (values: CreateCommunityEntityMutationMutationVariables) => {
    const response = await mutate({ variables: values });
    const createCommunityEntity = response.data?.createCommunityEntity;

    if (createCommunityEntity?.errors) {
      return {
        error: normalizeErrors(createCommunityEntity.errors),
        createCommunityEntity: null
      };
    }

    return {
      error: null,
      createCommunityEntity
    };
  };

  const message = data?.createCommunityEntity?.message || null;

  return children({
    submitCreateCommunityEntity,
    loading,
    error,
    message,
    createCommunityEntityData: data,
  });
};
